import { AnyAction } from 'redux';
import * as actionTypes from '../../../../models/actionTypes';
import { IAutoSuggestState, initialAutoSuggestState } from '../../../../models/reduxState';

const handleSocDataGrabSuccess = (state: IAutoSuggestState = initialAutoSuggestState, action: AnyAction) => {
    return {
        ...state,
        isAutoSuggestEnabled: !!action.supportSettingsConfig && !!action.supportSettingsConfig.IsAutoSuggestEnabled,
        isAutoSuggestV2Enabled: !!action.supportSettingsConfig && !!action.supportSettingsConfig.IsAutoSuggestV2Enabled,
        autoSuggestBaseUrl: !!action.supportSettingsConfig && !!action.supportSettingsConfig.AutoSuggestBaseUrl ? action.supportSettingsConfig.AutoSuggestBaseUrl : '',
        autoSuggestBaseUrlV2: !!action.supportSettingsConfig && !!action.supportSettingsConfig.AutoSuggestBaseUrlV2 ? action.supportSettingsConfig.AutoSuggestBaseUrlV2 : '',
    };
};

const handleSetAutoSuggestResult = (state: IAutoSuggestState = initialAutoSuggestState, action: AnyAction) => {
    return {
        ...state,
        autoSuggestResults: action.autoSuggestResults,
        isAutoSuggestHidden: !!action.autoSuggestResults && 0 < action.autoSuggestResults.length ? false : true,
    };
};

const handleSetAutoSuggestResultV2 = (state: IAutoSuggestState = initialAutoSuggestState, action: AnyAction) => {
    return {
        ...state,
        autoSuggestResultsV2: action.autoSuggestResultsV2,
        isAutoSuggestHidden: !!action.autoSuggestResultsV2 && 0 < action.autoSuggestResultsV2.suggestions?.length ? false : true,
    };
};

const handleToggleAutoSuggest = (state: IAutoSuggestState = initialAutoSuggestState, action: AnyAction) => {
    return {
        ...state,
        isAutoSuggestHidden: action.isAutoSuggestHidden,
    };
};

const handleSetContactSearchedQueryText = (state: IAutoSuggestState = initialAutoSuggestState, action: AnyAction) => {
    return {
        ...state,
        isAutoSuggestQuery: action.isAutoSuggestQuery,
    };
};

const handleSetAutoSuggestFocusedIndex = (state: IAutoSuggestState = initialAutoSuggestState, action: AnyAction) => {
    return {
        ...state,
        autoSuggestFocusedIndex: action.autoSuggestFocusedIndex,
    };
};

const handleSetOriginalQuery = (state: IAutoSuggestState = initialAutoSuggestState, action: AnyAction) => {
    return {
        ...state,
        originalQuery: action.originalQuery,
    };
};

/**
 * Whenever you define a new property to IAutoSuggestState, consider the need to reset it if it's impacted by search or ticket creation
 */
const handleSearchSessionReset = (state: IAutoSuggestState = initialAutoSuggestState) => {
    return {
        ...state,
        isAutoSuggestQuery: initialAutoSuggestState.isAutoSuggestQuery,
        originalQuery: initialAutoSuggestState.originalQuery,
        autoSuggestFocusedIndex: initialAutoSuggestState.autoSuggestFocusedIndex,
        autoSuggestResults: initialAutoSuggestState.autoSuggestResults,
        autoSuggestResultsV2: initialAutoSuggestState.autoSuggestResultsV2,
        isAutoSuggestHidden: initialAutoSuggestState.isAutoSuggestHidden,
    };
};

const handleSetAutoSuggestCardResult = (state: IAutoSuggestState = initialAutoSuggestState, action: AnyAction) => {
    if (!action.isAutoSuggestCardSearch) {
        return {
            ...state,
            autoSuggestCardResults: action.autoSuggestCardResults,
        };
    }
    return state;
};

const handleSetAutoSuggestCardResultV2 = (state: IAutoSuggestState = initialAutoSuggestState, action: AnyAction) => {
    if (!action.isAutoSuggestCardSearch) {
        return {
            ...state,
            autoSuggestCardResultsV2: action.autoSuggestCardResultsV2,
        };
    }
    return state;
};

export const AutoSuggestReducer = (state: IAutoSuggestState = initialAutoSuggestState, action: AnyAction) => {
    switch (action.type) {
        case actionTypes.GET_EMERALD_CONFIG_SUCCESS:
        case actionTypes.GET_EMERALD_SUPPORTCONFIG_SUCCESS:
            return handleSocDataGrabSuccess(state, action);
        case actionTypes.SET_AUTOSUGGEST_RESULT:
            return handleSetAutoSuggestResult(state, action);
        case actionTypes.SET_AUTOSUGGEST_RESULT_V2:
            return handleSetAutoSuggestResultV2(state, action);
        case actionTypes.TOGGLE_AUTOSUGGEST:
            return handleToggleAutoSuggest(state, action);
        case actionTypes.SET_CONTACT_SEARCHED_QUERY_TEXT:
            return handleSetContactSearchedQueryText(state, action);
        case actionTypes.SET_ORIGINAL_QUERY:
            return handleSetOriginalQuery(state, action);
        case actionTypes.SET_AUTOSUGGEST_FOCUSED_INDEX:
            return handleSetAutoSuggestFocusedIndex(state, action);
        case actionTypes.RESET_SEARCH_SESSION:
            return handleSearchSessionReset(state);
        case actionTypes.SET_IS_AUTOSUGGEST_CARD_SEARCH:
            return handleSetAutoSuggestCardResult(state, action);
        case actionTypes.SET_IS_AUTOSUGGEST_CARD_SEARCH_V2:
            return handleSetAutoSuggestCardResultV2(state, action);
        default:
            return state;
    }
};
